const $ = window.$, _ = window._
import React from "react"
import ButtonLoader from 'js/studios/shared/button_loader'
import {getErrors} from 'js/studios/shared/forms/utils'
import {sendRequest} from '../auth'
import {trackEventSP} from 'js/studios/shared/tracking'

export class ForgottenPasswordPanel extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      'successPage': false,
      'email': '',
      'errors': {},
      'resetPasswordLoading': false,
    }

    this.REQUIRED_FIELDS = ['email']
  }

  updateField(field, e){
    let newState = {}
    newState[field] = $(e.target).val()
    newState['errors'] = Object.assign({}, this.state.errors)
    delete newState['errors'][field]
    delete newState['errors']['global']
    this.setState(newState)
  }

  resetPassword(e){
    e.preventDefault()
    let data = _.pick(this.state, 'email')
    let errors = getErrors(data, this.REQUIRED_FIELDS),
        isValid = _.isEmpty(errors)
    this.setState({errors: errors})
    if (isValid){
      this.setState({
        'resetPasswordLoading': true
      })
      sendRequest('resetPassword', data)
        .then(() => {
          this.trackSubmit('Customer resets password', true, '', data.email)
          this.setState({
            resetPasswordLoading: false,
            successPage: true
          })
        })
        .catch(function(errorMessage){
          this.trackSubmit('Customer resets password', false, errorMessage, data.email)
          this.setState({
            resetPasswordLoading: false,
            errors: {
              'global': errorMessage
            }
          })
        }.bind(this))
    }

  }

  trackSubmit(name, success, reason_for_fail, email){
    trackEventSP(name, 'Customer sign up', {
      'success': success,
      'reason_for_fail': reason_for_fail,
      'email_address': email
    })
  }

  backToLogin(){
    this.props.navigateToPanel('login')
  }

  componentDidMount(){
    this.emailInput.focus()
  }

  render(){
    let content
    if (this.state.successPage){
      content = (
        <div>
          <header>
            <h2>Check your email!</h2>
            <p>We've sent you a link to a page that will let you change your password. You should receive it shortly.</p>
          </header>
        </div>
      )
    } else {
      let globalError = null
      if (this.state.errors.global){
        globalError = <div className="error_message">{this.state.errors.global}</div>
      }
      content = (
        <form onSubmit={this.resetPassword.bind(this)}>
          <header>
            <h2>Forgot your password</h2>
            <p>Enter your email address below and we'll send you a link to reset your password</p>
          </header>
          <fieldset>
            <input
              type="text"
              name="email"
              ref={(node) => this.emailInput = node}
              className={this.state.errors['email'] ? 'form-input error' : 'form-input'}
              aria-label="Email address"
              placeholder="Email address"
              value={this.state.email}
              onChange={this.updateField.bind(this, 'email')}
              />
            {globalError}
            <ButtonLoader type="submit" className="primary_button large btn btn-primary" loading={this.state.resetPasswordLoading} onClick={this.resetPassword.bind(this)}>Reset password</ButtonLoader>
          </fieldset>
        </form>
      )
    }

    return (
      <div className="panel_wrapper">
        <div className="forgot-password">
          <div className="inner">
            {content}
            <a className="back" onClick={this.backToLogin.bind(this)}>Back to login</a>
          </div>
        </div>
      </div>
    )
  }

}
